<template>
  <div class="hero-head" :style="{ height }" >
    <p class="debug" :style="{ 'background-color': bgcolor }"></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Header',
  componentName: 'Header',
  props: {
    height: {
      type: String,
      default: 'auto'
    }
  },
  data () {
    return {
      bgcolor: '',
      debug: ''
    }
  },
  created () {
    var host = location.host
    if (process.env.NODE_ENV === 'development') {
      this.debug = '〜 ローカル環境（ビルド[前]）〜'
      this.bgcolor = '#d6c6af'
    } else if (host === 'localhost:8000') {
      this.debug = '〜 ローカル環境（ビルド[済]）〜'
      this.bgcolor = '#EFFBF8'
    } else if (process.env.NODE_ENV === 'staging') {
      this.debug = '〜 ステージング環境　〜'
      this.bgcolor = '#ebf6f7'
    }
  }
}
</script>
<style scoped>

.debug {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 5px;
  z-index: -9999;
}

hr {
  margin: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue